<script>
import FormCreator from '../UI/Form/FormCreator.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import DocumentList from '../Document/DocumentList.vue'
import DocumentDownloadButton from '../Document/DocumentDownloadButton.vue'
import DocumentShowAction from '../Document/DocumentShowAction.vue'
import MessageList from '../Message/MessageList.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../Mixins/global'
import ContractCessionRelationBadge from './ContractCessionRelationBadge.vue'
import UserSelect from '../UI/Form/UserSelect.vue'

export default {
  components: {
    ContractCessionRelationBadge,
    BlockContent,
    ButtonAll,
    DocumentDownloadButton,
    DocumentList,
    DocumentShowAction,
    FieldCreator,
    FormCreator,
    MessageList,
    UserSelect,
  },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    id: { type: [String, Number], required: true },
    contract: { type: Object, required: true },
    def: { type: Object, required: true },
  },

  data() {
    return {
      documentsI: [],
      messages: [],
      messageId: '',
      loadField: false,
      preparing: false,
      validating: false,
      cancelling: false,
      loading: false,
      formData: null,
    }
  },
  computed: {
    paymentTermLabel() {
      return this.$t(`paymentTerm.choices.${this.contract.finance.paymentTerm.code}`)
    },
  },
  methods: {
    updateData(newData) {
      this.formData = newData
    },
    setBuild(bool) {
      this.loadField = bool
    },
    objectReturn({ object, sending }) {
      this.preparing = sending
      this.validating = sending
      this.cancelling = sending
    },
    documentLoaded(obj) {
      let documents = {}
      documents = obj.documents
      documents.map((document) => {
        switch (document.code) {
          case 'welcome_letter_refinance':
          case 'welcome_letter':
          case 'schedule':
          case 'insurance':
          case 'invoice_first':
            this.documentsI.push(document)
            break
        }
      })

      this.$refs.messagelist.callbackMessage()
    },
    async prepareSetup() {
      this.preparing = true
      this.$refs.formsetup.inject['error'] = undefined

      try {
        this.$refs.formsetup.methods(null, true, 'prepareSetup')
      } finally {
        this.preparing = false
      }
    },
    async validateSetup() {
      this.validating = true

      try {
        await this.$refs.formsetup.methods(null, true, 'validateSetup')
      } finally {
        this.validation = false
      }
    },
    async cancelSetup() {
      this.cancelling = true

      try {
        await this.$refs.formsetup.methods(null, true, 'cancelSetup')
      } finally {
        this.cancelling = false
      }
    },
    contractContainsActorType(type) {
      return this.contract?.finance?.actors?.some((actor) => actor.type === type)
    },
    onError() {
      this.preparing = false
      this.validating = false
      this.cancelling = false
    },
  },
}
</script>
<template>
  <div>
    <div class="row" v-if="Object.keys(def).length > 0 && Object.keys(contract).length > 0">
      <FormCreator
        @update-data="updateData"
        ref="formsetup"
        src-error="formsetup"
        endpoint="contracts"
        :id="id"
        method="patch"
        :config-def="def"
        :config-object="contract"
        dynamic
        class-to-add="d-none"
        @form-build="setBuild"
        @object-return="objectReturn"
        @error="onError"
      />
      <div class="col col-md-7">
        <BlockContent title-t="contract.setup.menu" e2e-block="contractSetup">
          <div class="my-2 row">
            <label class="fs-16 form-label-font col-xl-4 col-md-12">{{
              $t('contract.setup.fields.deliveredAt.label')
            }}</label>
            <div class="col-xl-8 col-md-12 font-weight-bold" e2e-data="contractDeliveredAt">
              {{
                Object.keys(contract).length > 0
                  ? contract.deliveredAt
                    ? setDate(contract.deliveredAt, 'date')
                    : ''
                  : ''
              }}
            </div>
          </div>
          <div
            class="my-2 row"
            v-if="Object.keys(contract).length > 0 ? (contract.operationalAt ? contract.operationalAt : '') : ''"
          >
            <label class="fs-16 form-label-font col-xl-4 col-md-12">{{
              $t('contract.setup.fields.operationalAt.label')
            }}</label>
            <div class="col-xl-8 col-md-12 font-weight-bold" e2e-data="contractOperationalAt">
              {{ setDate(contract.operationalAt, 'date') }}
            </div>
          </div>
          <FieldCreator
            :form-data="formData"
            v-if="loadField"
            name="startAt"
            domain="contract"
            form-ref="formsetup"
            :label-left="true"
            :min-datetime="contract.deliveredAt"
          ></FieldCreator>
          <FieldCreator
            :form-data="formData"
            name="managerSalesman"
            form-ref="formsetup"
            domain="contract"
            label-left
          />
          <FieldCreator
            :form-data="formData"
            name="salesmanAssistant"
            form-ref="formsetup"
            domain="contract"
            label-left
          />
          <template v-if="hasRole('ROLE_INDEXATION_INDICATORS_SHOW')">
            <div class="my-2 row">
              <label class="fs-16 form-label-font col-xl-4 col-md-12">{{
                $t('contract.setup.fields.averageIndexationIndicatorAtContractSigning.label')
              }}</label>
              <div
                class="col-xl-8 col-md-12 font-weight-bold"
                e2e-data="contractAverageIndexationIndicatorAtContractSigning"
              >
                {{ $n(Number(contract.averageIndexationIndicatorAtContractSigning), 'decimal') }}%
              </div>
            </div>
            <div class="my-2 row" v-if="hasRole('ROLE_INDEXATION_INDICATORS_SHOW')">
              <label class="fs-16 form-label-font col-xl-4 col-md-12">{{
                $t('contract.setup.fields.averageIndexationIndicatorAtContractDelivery.label')
              }}</label>
              <div
                class="col-xl-8 col-md-12 font-weight-bold"
                e2e-data="contractAverageIndexationIndicatorAtContractDelivery"
              >
                {{ $n(Number(contract.averageIndexationIndicatorAtContractDelivery), 'decimal') }}%
              </div>
            </div>
          </template>
        </BlockContent>
        <BlockContent e2e-bloc="contractSetupInvoice">
          <template #header-title>
            <div class="d-flex justify-content-between">
              <h4>
                {{
                  $t(contractContainsActorType('MANAGER') ? 'contract.setup.invoiceManager' : 'contract.setup.invoice')
                }}
              </h4>
              <div>
                <ContractCessionRelationBadge :contract="contract" />
              </div>
            </div>
          </template>
          <UserSelect
            :form-data="formData"
            :input-id="`billingContacts-formsetup`"
            :client-id="contract.client?.id"
            :contract-id="id"
            :entity-id="contract.clientActor?.entity?.id"
            name="billingContacts"
            form-ref="formsetup"
            domain="actor"
            user-entity
            multiple
            label-wrapper-classes="col-xl-4 col-md-12 d-flex justify-content-between"
            input-wrapper-classes="col-xl-8 col-md-12"
          />
          <FieldCreator
            :form-data="formData"
            name="billingAddress"
            form-ref="formsetup"
            domain="actor"
            label-left
          ></FieldCreator>
          <FieldCreator
            :form-data="formData"
            label-property="code"
            value-property="id"
            name="billingCode"
            form-ref="formsetup"
            domain="actor"
            label-left
          ></FieldCreator>
          <FieldCreator :form-data="formData" name="paymentDay" domain="contract" form-ref="formsetup" label-left />
          <div class="my-2 row">
            <label class="fs-16 form-label-font col-xl-4 col-md-12">{{
              $t('contract.setup.fields.paymentMean.label')
            }}</label>
            <div class="col-xl-8 col-md-12 font-weight-bold" v-if="contract.finance" e2e-data="contractPaymentMeanName">
              {{ contract.finance.paymentMean.name }}
            </div>
          </div>
          <div class="my-2 row">
            <label class="fs-16 form-label-font col-xl-4 col-md-12">
              {{ $t('contract.setup.fields.paymentTerm.label') }}</label
            >

            <div class="col-xl-8 col-md-12 font-weight-bold" v-if="contract.finance" e2e-data="contractPaymentTermName">
              {{ paymentTermLabel }}
            </div>
          </div>
          <FieldCreator
            :form-data="formData"
            name="paymentDelay"
            domain="contract"
            form-ref="formsetup"
            :label-left="true"
            :placeholder-config="false"
          ></FieldCreator>

          <FieldCreator
            :form-data="formData"
            name="invoiceMiddleRent"
            domain="contract"
            form-ref="formsetup"
            :label-left="true"
          />
          <FieldCreator
            :form-data="formData"
            name="ribCompany"
            domain="contract"
            form-ref="formsetup"
            :label-left="true"
          />
          <FieldCreator
            :form-data="formData"
            name="managementMandate"
            domain="contract"
            form-ref="formsetup"
            :label-left="true"
          />
          <FieldCreator
            :form-data="formData"
            name="finance.courtRegistryAmount"
            domain="contract"
            form-ref="formsetup"
            :label-left="true"
          />
          <FieldCreator
            :form-data="formData"
            name="applicationFee"
            domain="contract"
            form-ref="formsetup"
            :label-left="true"
          />
          <div v-if="!user.isReadOnly" class="row col justify-content-start">
            <ButtonAll
              v-if="!contract.prepareSetupAt"
              margin="no"
              type="validation"
              label="contract.setup.action.prepare"
              @click="prepareSetup"
              :loading="preparing"
              name="prepareSetup"
            />
            <ButtonAll
              v-if="contract.prepareSetupAt && !contract.setupAt"
              margin="no"
              type="validation"
              label="contract.setup.action.validate"
              @click="validateSetup"
              :loading="validating"
              name="validateSetup"
            />
            <ButtonAll
              v-if="contract.prepareSetupAt && !contract.setupAt"
              margin="no"
              type="warning"
              class="ml-2"
              label="contract.setup.action.cancel"
              @click="cancelSetup"
              :loading="cancelling"
              name="cancelSetup"
            />
          </div>
        </BlockContent>
      </div>
      <div class="col col-md-5">
        <BlockContent title-t="contract.setup.documents" e2e-block="contractSetupDocuments">
          <DocumentList
            ref="documentlist"
            load-only
            context="Contract"
            :context-id="Number(id)"
            @document-loaded="documentLoaded"
          />
          <table class="table table-striped table-hover fs-16">
            <thead>
              <tr>
                <th>{{ $t('document.table.labelDocument') }}</th>
                <th>{{ $t('document.table.labelStatus') }}</th>
                <th class="text-center">{{ $t('document.table.labelAction') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="documentI in documentsI">
                <td><DocumentDownloadButton :document="documentI" /></td>
                <td>
                  <div class="d-flex">
                    <span v-html="$refs.documentlist.getStatus(documentI)"></span>
                    <span v-if="documentI.document.status == 'INCOMPLETE'"
                      ><br /><b>{{ $t('document.incompleteHelp') }}</b></span
                    >
                    <span v-if="documentI.document.errors.length > 0"
                      ><ul>
                        <li v-for="error in documentI.document.errors">{{ error.message }}</li>
                      </ul></span
                    >
                  </div>
                </td>
                <td class="d-flex">
                  <DocumentShowAction :document="documentI" />
                  <DocumentDownloadButton :document="documentI" have-btn />
                </td>
              </tr>
            </tbody>
          </table>
        </BlockContent>
        <BlockContent title-t="contract.setup.communication">
          <MessageList
            ref="messagelist"
            context="AppBundle\Entity\Contract"
            :context-id="Number(id)"
            context-validate
            api-call
          ></MessageList>
        </BlockContent>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col col-md-7">
          <BlockContent title-t="contract.setup.menu">
            <div class="row">
              <div class="col flex-fill">
                <div class="row py-3 mb-3 mx-3 loading"></div>
                <div class="row py-3 mb-3 mx-3 loading"></div>
                <div class="row py-3 mb-3 mx-3 loading"></div>
              </div>
            </div>
          </BlockContent>
        </div>
        <div class="col col-md-5">
          <BlockContent title-t="contract.setup.documents">
            <div class="row">
              <div class="col flex-fill">
                <div class="row py-3 mb-3 mx-3 loading"></div>
                <div class="row py-3 mb-3 mx-3 loading"></div>
              </div>
            </div>
          </BlockContent>
        </div>
      </div>
    </div>
  </div>
</template>
